import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function NotFoundPage() {
  return (
    <div className="app-container">
      <Header />

      <main className="main-content content-page">
        <div className="not-found-container">
          <h1 className="not-found-title">404</h1>
          <h2>Page Not Found</h2>
          <p>
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>

          <div className="not-found-actions">
            <Link to="/leaderboard/D1" className="btn-primary">
              Go to Leaderboard
            </Link>
            <Link to="/competition" className="btn-secondary">
              Competition Info
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
